import * as styled from '../../../../util/styled'

const ImgTombstone = styled.div('w-full h-full bg-surface-darker rounded-lg')
const CTATombstone = styled.div('w-[9em] h-[1em] bg-surface-darker rounded-lg')
const TextTombstone = styled.div('h-[1em] bg-surface-darker rounded mb-[.25em]')

import { ResultLayout } from './ResultLayout'

export const Skeleton = () => {
  return (
    <ResultLayout
      className='animate-pulse'
      image={<ImgTombstone />}
      domain={<TextTombstone className='w-[12em]' />}
      title={<TextTombstone className='w-[25em]' />}
      description={(
        <>
          <TextTombstone className='w-full' />
          <TextTombstone className='w-2/3'/>
        </>
      )}
      analytics={[
        { key: 'views', title: <TextTombstone className="w-[12em]" />, value: <TextTombstone className="w[6em]" /> },
        { key: 'clicks', title: <TextTombstone className="w-[12em]" />, value: <TextTombstone className="w[6em]" /> },
      ]}
      cta={<CTATombstone />}
    />
  )
}
